import { render, staticRenderFns } from "./tableRomaneioConferenciaSaida.vue?vue&type=template&id=4b58e05c&scoped=true&"
import script from "./tableRomaneioConferenciaSaida.vue?vue&type=script&lang=js&"
export * from "./tableRomaneioConferenciaSaida.vue?vue&type=script&lang=js&"
import style0 from "./tableRomaneioConferenciaSaida.vue?vue&type=style&index=0&id=4b58e05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58e05c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDivider,VIcon,VList,VMenu,VTextField,VToolbar})
